import React from 'react'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import { Chip } from '../Goals/Goals.styled'

type UnassignedTasksChipProps = {
  iconColorStyles: Record<string, unknown>
  numTasksUnassigned: number
}

export const UnassignedTasksChip = ({
  iconColorStyles,
  numTasksUnassigned,
}: UnassignedTasksChipProps) => (
  <Chip variant={numTasksUnassigned > 0 ? 'unassigned' : 'completed'}>
    {numTasksUnassigned > 0 ? (
      <ReportProblemOutlinedIcon sx={iconColorStyles} />
    ) : (
      <CheckCircleOutlineOutlinedIcon sx={iconColorStyles} />
    )}
    {numTasksUnassigned > 0
      ? `${numTasksUnassigned} Unassigned Tasks`
      : 'All Tasks Assigned'}
  </Chip>
)
